import { BusinessUnitInclude } from './BusinessUnit';
export var TargetInclude = {
    organization: true,
    businessUnit: { include: BusinessUnitInclude },
    aims: true,
};
//# sourceMappingURL=Target.js.map